// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Overlay */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    -webkit-backdrop-filter: blur(4px);
            backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3000;
    animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Modal Content */
.create-modal {
    background: white;
    border-radius: 16px;
    max-width: 800px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    animation: modalSlideUp 0.3s ease;
}

@keyframes modalSlideUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Modal Header */
.modal-header {
    padding: 1.5rem;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-header h2 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1a202c;
    margin: 0;
}

.modal-close-btn {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: none;
    background: #f7fafc;
    color: #718096;
    font-size: 1.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-close-btn:hover {
    background: #edf2f7;
    color: #2d3748;
}

/* Modal Error */
.modal-error {
    margin: 1rem 1.5rem;
    padding: 1rem;
    background: #fff5f5;
    border-left: 4px solid #fc8181;
    color: #c53030;
    border-radius: 8px;
    font-size: 0.9rem;
}

/* Form */
.create-form {
    padding: 1.5rem;
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1rem;
    gap: 1rem;
}

.form-group {
    margin-bottom: 1.25rem;
}

.form-group label {
    display: block;
    font-weight: 600;
    color: #2d3748;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
}

.form-group input {
    width: 100%;
    padding: 0.75rem;
    border: 2px solid #e2e8f0;
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.3s ease;
}

.form-group input:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-group input:disabled {
    background: #f7fafc;
    cursor: not-allowed;
}

.form-hint {
    display: block;
    margin-top: 0.5rem;
    font-size: 0.8rem;
    color: #718096;
}

/* Modal Actions */
.modal-actions {
    display: flex;
    gap: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #e2e8f0;
}

.btn {
    flex: 1 1;
    padding: 0.875rem 1.5rem;
    border-radius: 8px;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

.btn.btn-cancel {
    background: #edf2f7;
    color: #4a5568;
}

.btn.btn-cancel:hover:not(:disabled) {
    background: #e2e8f0;
}

.btn.btn-primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
}

.btn.btn-primary:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Permission Selection Styles */
.form-section {
    margin-bottom: 1.5rem;
    padding: 1rem;
    background: #f7fafc;
    border-radius: 12px;
}

.form-section h3 {
    font-size: 1.1rem;
    font-weight: 700;
    color: #2d3748;
    margin: 0 0 0.5rem 0;
}

.section-hint {
    font-size: 0.85rem;
    color: #718096;
    margin: 0 0 1rem 0;
}

.all-access-alert {
    padding: 1rem;
    background: linear-gradient(135deg, #fef5e7 0%, #fdebd0 100%);
    border-left: 4px solid #f39c12;
    border-radius: 8px;
    color: #7d6608;
    font-size: 0.9rem;
}

.permission-category-group {
    margin-bottom: 1.5rem;
}

.permission-category-group h4 {
    font-size: 0.9rem;
    font-weight: 600;
    color: #4a5568;
    margin: 0 0 0.75rem 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.permission-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    grid-gap: 0.75rem;
    gap: 0.75rem;
}

.permission-pill {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    background: white;
    border: 2px solid #e2e8f0;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    -webkit-user-select: none;
            user-select: none;
}

.permission-pill:hover {
    border-color: #cbd5e0;
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.permission-pill.active {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-color: #667eea;
    color: white;
}

.permission-pill .p-icon {
    font-size: 1.2rem;
}

.permission-pill .p-label {
    font-size: 0.85rem;
    font-weight: 500;
}

.modal-select {
    width: 100%;
    padding: 0.75rem;
    border: 2px solid #e2e8f0;
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.3s ease;
    background: white;
    cursor: pointer;
}

.modal-select:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.modal-select:disabled {
    background: #f7fafc;
    cursor: not-allowed;
}

/* Responsive */
@media (max-width: 768px) {
    .create-modal {
        max-width: 95%;
    }

    .form-row {
        grid-template-columns: 1fr;
    }

    .modal-header h2 {
        font-size: 1.25rem;
    }

    .modal-actions {
        flex-direction: column;
    }

    .btn {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/admin/CreateAdminModal.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,kCAA0B;YAA1B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;IAC1C,iCAAiC;AACrC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,SAAS;AACT;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAS;IAAT,SAAS;AACb;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,SAAO;IACP,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,gCAAgC;AAChC;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,6DAA6D;IAC7D,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,iBAAY;IAAZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI;QACI,cAAc;IAClB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":["/* Modal Overlay */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.6);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 3000;\n    animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n/* Modal Content */\n.create-modal {\n    background: white;\n    border-radius: 16px;\n    max-width: 800px;\n    width: 90%;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n    animation: modalSlideUp 0.3s ease;\n}\n\n@keyframes modalSlideUp {\n    from {\n        opacity: 0;\n        transform: translateY(30px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Modal Header */\n.modal-header {\n    padding: 1.5rem;\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.modal-header h2 {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #1a202c;\n    margin: 0;\n}\n\n.modal-close-btn {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    border: none;\n    background: #f7fafc;\n    color: #718096;\n    font-size: 1.5rem;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.modal-close-btn:hover {\n    background: #edf2f7;\n    color: #2d3748;\n}\n\n/* Modal Error */\n.modal-error {\n    margin: 1rem 1.5rem;\n    padding: 1rem;\n    background: #fff5f5;\n    border-left: 4px solid #fc8181;\n    color: #c53030;\n    border-radius: 8px;\n    font-size: 0.9rem;\n}\n\n/* Form */\n.create-form {\n    padding: 1.5rem;\n}\n\n.form-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n}\n\n.form-group {\n    margin-bottom: 1.25rem;\n}\n\n.form-group label {\n    display: block;\n    font-weight: 600;\n    color: #2d3748;\n    margin-bottom: 0.5rem;\n    font-size: 0.9rem;\n}\n\n.form-group input {\n    width: 100%;\n    padding: 0.75rem;\n    border: 2px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 1rem;\n    transition: all 0.3s ease;\n}\n\n.form-group input:focus {\n    outline: none;\n    border-color: #667eea;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-group input:disabled {\n    background: #f7fafc;\n    cursor: not-allowed;\n}\n\n.form-hint {\n    display: block;\n    margin-top: 0.5rem;\n    font-size: 0.8rem;\n    color: #718096;\n}\n\n/* Modal Actions */\n.modal-actions {\n    display: flex;\n    gap: 1rem;\n    padding-top: 1rem;\n    border-top: 1px solid #e2e8f0;\n}\n\n.btn {\n    flex: 1;\n    padding: 0.875rem 1.5rem;\n    border-radius: 8px;\n    font-weight: 600;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n\n.btn.btn-cancel {\n    background: #edf2f7;\n    color: #4a5568;\n}\n\n.btn.btn-cancel:hover:not(:disabled) {\n    background: #e2e8f0;\n}\n\n.btn.btn-primary {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n}\n\n.btn.btn-primary:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.spinner {\n    width: 16px;\n    height: 16px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top-color: white;\n    border-radius: 50%;\n    animation: spin 0.6s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Permission Selection Styles */\n.form-section {\n    margin-bottom: 1.5rem;\n    padding: 1rem;\n    background: #f7fafc;\n    border-radius: 12px;\n}\n\n.form-section h3 {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: #2d3748;\n    margin: 0 0 0.5rem 0;\n}\n\n.section-hint {\n    font-size: 0.85rem;\n    color: #718096;\n    margin: 0 0 1rem 0;\n}\n\n.all-access-alert {\n    padding: 1rem;\n    background: linear-gradient(135deg, #fef5e7 0%, #fdebd0 100%);\n    border-left: 4px solid #f39c12;\n    border-radius: 8px;\n    color: #7d6608;\n    font-size: 0.9rem;\n}\n\n.permission-category-group {\n    margin-bottom: 1.5rem;\n}\n\n.permission-category-group h4 {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #4a5568;\n    margin: 0 0 0.75rem 0;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.permission-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n    gap: 0.75rem;\n}\n\n.permission-pill {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    background: white;\n    border: 2px solid #e2e8f0;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    user-select: none;\n}\n\n.permission-pill:hover {\n    border-color: #cbd5e0;\n    transform: translateY(-2px);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.permission-pill.active {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    border-color: #667eea;\n    color: white;\n}\n\n.permission-pill .p-icon {\n    font-size: 1.2rem;\n}\n\n.permission-pill .p-label {\n    font-size: 0.85rem;\n    font-weight: 500;\n}\n\n.modal-select {\n    width: 100%;\n    padding: 0.75rem;\n    border: 2px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 1rem;\n    transition: all 0.3s ease;\n    background: white;\n    cursor: pointer;\n}\n\n.modal-select:focus {\n    outline: none;\n    border-color: #667eea;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.modal-select:disabled {\n    background: #f7fafc;\n    cursor: not-allowed;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .create-modal {\n        max-width: 95%;\n    }\n\n    .form-row {\n        grid-template-columns: 1fr;\n    }\n\n    .modal-header h2 {\n        font-size: 1.25rem;\n    }\n\n    .modal-actions {\n        flex-direction: column;\n    }\n\n    .btn {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
